import { render, staticRenderFns } from "./NoticeSendManagement.vue?vue&type=template&id=52a25312&scoped=true"
import script from "./NoticeSendManagement.vue?vue&type=script&lang=js"
export * from "./NoticeSendManagement.vue?vue&type=script&lang=js"
import style0 from "./NoticeSendManagement.vue?vue&type=style&index=0&id=52a25312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a25312",
  null
  
)

export default component.exports